export default __webpack_public_path__ + "static/media/ciaran.84267f5a.png";